import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactNode } from 'react';

import { locator } from '../../testing/e2e-locator/locator';

/**
 * Custom checked checkbox icon used as the `checkedIcon` prop on MUI Checkbox components.
 * Uses a stroke-based checkmark on a filled primary-color background, replacing MUI's default
 * fill-based icon which renders with a thicker, less refined appearance.
 */
export const CheckedIcon = (props: SvgIconProps): ReactNode => (
  <SvgIcon
    {...props}
    data-testid={locator.components.checkedIcon.root}
    viewBox="0 0 24 24"
  >
    <rect fill="currentColor" height="24" rx="3" width="24" x="0" y="0" />
    <path
      d="M4 12L10 18L20 6"
      fill="none"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </SvgIcon>
);
